import UploadFileDialog from "./UploadFileDialog";
import {useNews} from "../../context/NewsContext";
import {updatePhotoNews} from "../../clients/NewsApiClient";

export const UpdatePhotoForm = () => {

    const {photoRedacted, setPhotoRedacted, selectedNews, refreshNews} = useNews();

    if (!photoRedacted) {
        return null;
    }

    function closeModal() {
        setPhotoRedacted(false);
    }

    async function handleSubmit(file) {
        const id = selectedNews?.id
        await updatePhotoNews(file, id);
        await refreshNews();
        setPhotoRedacted(false);
    }

    return (
        <UploadFileDialog
            onClose={closeModal}
            isOpen={photoRedacted}
            accept={'image/*'}
            onSubmit={handleSubmit}
            text={'📁 Прикрепите фото новости'}
        />
    );
}